import { useTranslation } from 'next-i18next';
import styled from '@emotion/styled';
import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import { blue, gray } from '@styles/Colors';

type TimelineItemContent = {
  description?: string;
  isHighlight?: boolean;
};

export type TimelineItem = {
  title: string;
  contents: {
    date: string;
    items?: TimelineItemContent[];
  }[];
};

type TimelineItemProps = {
  item: TimelineItem;
};

/** 타임라인 아이템 컴포넌트 (연 단위) */
export default function TimelineItem({ item }: TimelineItemProps) {
  const { t } = useTranslation('intro');

  return (
    <TimelineItemContainer>
      <Typography variant={TypoVariant.SH1} color={blue.blue3}>
        {item.title}
      </Typography>

      {item.contents.map((content, contentIdx) => {
        const isHighlight = content.items?.some((item) => item.isHighlight);
        return (
          <Contents key={`${item.title}-${content.date}-${contentIdx}`}>
            {/* 월 단위 */}
            <Typography variant={TypoVariant.SH3} color={isHighlight ? blue.blue3 : gray.gray7}>
              {t(`section1.${content.date}`)}
            </Typography>

            {/* 월 단위 내용 */}
            {content.items?.map((contentItem, idx) => (
              <Typography
                key={`${content.date}-item-${idx}`}
                variant={TypoVariant.B3}
                color={contentItem.isHighlight ? blue.blue3 : gray.gray7}>
                {t(`section1.${contentItem.description}`)}
              </Typography>
            ))}
          </Contents>
        );
      })}
    </TimelineItemContainer>
  );
}

const TimelineItemContainer = styled.div<{ marginTop?: string; isLeft?: boolean }>`
  flex: 1;
  display: grid;
  row-gap: 16px;

  margin-top: ${({ marginTop }) => marginTop};

  ${({ isLeft }) =>
    isLeft &&
    `
    text-align: right;
  `}
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
`;
